import {
  buildPlanningSessionAgentPrompt,
  buildPlanningSessionFollowUpAgentPrompt,
  parseSessionKind,
  type PlanningTodoItem,
} from '@buildautomaton/types';
import { fetchCloudSessionMeta } from '../../mcp/tools/session-history/fetch-parent-session-cloud.js';

/** Enrich the user prompt for planning sessions before sending to the local agent. */
export async function enrichPlanningSessionPromptForAgent(params: {
  sessionId: string;
  promptText: string;
  isNewSession: boolean;
  cloudApiBaseUrl: string;
  getCloudAccessToken: () => string;
}): Promise<{ promptText: string; isPlanningSession: boolean }> {
  const meta = await fetchCloudSessionMeta({
    sessionId: params.sessionId,
    cloudApiBaseUrl: params.cloudApiBaseUrl,
    getCloudAccessToken: params.getCloudAccessToken,
  });
  if (!meta.ok) return { promptText: params.promptText, isPlanningSession: false };
  const sessionKind = parseSessionKind(meta.data.sessionKind);
  if (sessionKind !== 'planning') return { promptText: params.promptText, isPlanningSession: false };

  const todos = Array.isArray(meta.data.planningTodos)
    ? (meta.data.planningTodos as PlanningTodoItem[])
    : [];

  if (params.isNewSession || todos.length === 0) {
    return {
      promptText: buildPlanningSessionAgentPrompt(params.promptText),
      isPlanningSession: true,
    };
  }
  return {
    promptText: buildPlanningSessionFollowUpAgentPrompt(params.promptText, todos),
    isPlanningSession: true,
  };
}
